
import { defHttp } from '/@/utils/http/axios';
import { LoginParams } from './model/userModel';

import { ErrorMessageMode } from '/#/axios';

enum Api {
  Login = '/login',
  Logout = '/logout',
  GetLoginUserInfo = '/getLoginUserInfo',
}

/**
 * 用户登录
 * @param params
 * @param mode
 * @returns
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  return defHttp.post<string>(
    {
      url: Api.Login,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
}

/**
 * 用户登出
 * @param params
 * @param mode
 * @returns
 */
export function doLogout() {
  return defHttp.get<any>({ url: Api.Logout });
}

/**
 * 获取登录用户信息
 * @returns
 */
export function getLoginUserInfo() {
  return defHttp.get<any>({
    url: Api.GetLoginUserInfo,
  });
}

/**
 * 获取用户配置
 * @returns
 */
 export function getUserSetting(params: any) {
  return defHttp.get<any>({url: "/getUserSetting", params});
}

/**
 * 设置用户配置
 * @returns
 */
 export function setUserSetting(params: any) {
  return defHttp.post<any>({url: "/setUserSetting", params});
}
